import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import LightRays from '../effects/LightRays/LightRays';
import './Experience.css';

const Experience = () => {
  const [darkTheme, setDarkTheme] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const experiences = {
  internship: [
    {
      id: 1,
      title: "Web Developer Intern",
      company: "GauravGo Games Technologies",
      duration: "Oct 2023 – Present",
      description: [
        "Developed and maintained responsive web pages",
        "Worked remotely on front-end design and integration",
        "Used Java and HTML to enhance user interaction"
      ],
      skills: ["Java", "HTML", "Web Development"]
    },
    {
      id: 2,
      title: "Java Programmer Intern",
      company: "Cognifyz Technologies",
      duration: "Jul 2024 – Present",
      description: [
        "Contributed to backend modules in Java",
        "Implemented reusable code and modular logic",
        "Worked in a hybrid environment collaborating with peers"
      ],
      skills: ["Java", "OOP", "Backend Development"]
    }
  ],
  hackathon: [
    {
      id: 1,
      title: "Algoverse 2025",
      event: "HackWithIndia IGDTUW",
      duration: "National-Level Hackathon",
      description: [
        "Led a team through intense problem-solving and brainstorming",
        "Managed technical architecture and development strategy",
        "Delivered a fully working solution under high-pressure",
        "Recognized for leadership and collaboration"
      ],
      skills: ["Leadership", "React", "Team Management","Firebase Auth", "JavaScript",  "Express.js","MongoDB", "Netlify","HTML5",
  "CSS3",]

  
    },
    {
      id: 2,
      title: "BuildVerse 2025",
      event: "Scaler School of Technology",
      duration: "24-hour Hackathon",
      description: [
        "Built a smart healthcare web app in 24 hours",
        "Implemented OCR for report scanning and disease detection",
        "Used AI for hospital recommendations and diagnosis support",
        "One of 126 teams selected from 1900+ registrations"
      ],
     skills: [
  "MongoDB",
  "Express.js",
  "React.js",
  "Node.js",
  "JavaScript",
  "HTML5",
  "CSS3",
  "Bootstrap 5",
  "jWT",
  "Firestore",
  "Netlify",
  "Vercel"
]
    },
    {
      id: 3,
      title: "EcoCart – Sustainable Shopping Assistant",
      event: "Prabal National Hackathon 2025",
      duration: "Finalist Round",
      description: [
        "Developed a green product recommendation web app",
        "Integrated eco-badge ratings and Firebase authentication",
        "Designed fully responsive UI with smooth user experience",
        "Built with Bootstrap, JS, Firebase, and modern UI/UX tools"
      ],
      skills: [
  "MongoDB",
  "Express.js",
  "React.js",
  "Node.js",
  "JavaScript",
  "HTML5",
  "CSS3",
  "Bootstrap 5",
  "Firebase Auth",
  "Firestore",
  "UI/UX",
  "Netlify",
  "Vercel"
]
    }
  ]
};


  const renderSection = (type, label) => (
    <div className="experience-section">
      <motion.h3
        className="subheading"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {label}
      </motion.h3>

      <div className="experience-grid">
        {experiences[type].map((exp, index) => (
          <motion.div
            key={exp.id}
            className="experience-item"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.6 }}
            whileHover={{ y: isMobile ? 0 : -5 }}
          >
            <div className="experience-header">
              <div className="experience-icon">
                <div className="icon-circle" />
                <div className="icon-inner" />
              </div>
              <div className="experience-title">
                <h3>{exp.title}</h3>
                <h4>{exp.company || exp.event}</h4>
                <span className="duration">{exp.duration}</span>
              </div>
            </div>
            <div className="experience-content">
              <ul className="description">
                {exp.description.map((item, i) => (
                  <motion.li
                    key={i}
                    whileHover={{ x: isMobile ? 0 : 5 }}
                    transition={{ type: 'spring', stiffness: 300 }}
                  >
                    <span className="bullet">↠</span> {item}
                  </motion.li>
                ))}
              </ul>
              <div className="skills-container">
                {exp.skills.map((skill, i) => (
                  <motion.span
                    key={i}
                    className="skill-pill"
                    whileHover={{ scale: isMobile ? 1 : 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {skill}
                  </motion.span>
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );

  return (
    <div className={`experience-container ${darkTheme ? 'dark' : 'light'}`}>
      {/* LightRays Background - Right Side */}
      <div className="light-rays-background">
        <LightRays
          raysOrigin="right"
          raysColor={darkTheme ? "rgba(255, 255, 255, 0.3)" : "rgba(255, 255, 255, 0.2)"}
          raysSpeed={1.5}
          lightSpread={3}
          rayLength={isMobile ? 0.8 : 5}
          followMouse={!isMobile}
          mouseInfluence={isMobile ? 0 : 0.1}
          noiseAmount={0.1}
          distortion={0.05}
        />
      </div>

      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <span className="title-accent">My</span> Experiences
      </motion.h2>

      {renderSection('internship', 'Internships')}
      {renderSection('hackathon', 'Hackathons')}
    </div>
  );
};

export default Experience;